import React, {useEffect, useState} from "react";
import {titleCase} from "../../../Users/addUser";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Label, { FormLabel }  from "../../../Utils/FormInputs/Label";
import ClearIcon from '@material-ui/icons/Clear';
import {CustomSelect} from "../../../Utils/FormInputs/SelectInput";
import TextField from "../../../Utils/FormInputs/TextField";
import {makeStyles} from '@material-ui/core/styles';
import {CustomResizableTextarea } from "../../../Inventory/CustomInput";
import { useTheme } from "@emotion/react";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import Alert from "@material-ui/lab/Alert";
import {RightAlignedContainer} from "../../../Utils/styledComponents";

const useStyles = makeStyles(() => ({
    root: {
        width: '.8em',
    }
}));

const RecordTriage = ({actions, patient_number, visit_id,isSubmitted, setIsSubmitted,setOpenDialog}) => {

    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;

    const [allMetrics, setAllMetrics] = useState([])
    const [triageList, setTriageList] = useState([]);
    const [triage, setTriage] = useState([])
    const [{weight_metric_id, weight_metric_name}, setWeight] = useState({weight_metric_id: 2, weight_metric_name: '', weight_patientmsr_id:''});
    const [{height_metric_id, height_metric_name}, setHeight] = useState({height_metric_id: 1, height_metric_name: '', height_patientmsr_id:''});
    const [bmi, setBMI] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [otherMetric, setOtherMetric] = useState('');
    const [others, setOthers] = useState([]);
    const [optionalMetrics, setOptionalMetrics] = useState([]);

    const [allergies, setAllergies] = useState('')
    const [hasAllergies, setHasAllergies] = useState(false)
    const [chronic_illness, setChronicIllness] = useState({cardiac_disease:false, kidney_disease:false,
        hypertension:false, tb:false, asthma:false, sti:false, sickle_cell_disease:false, epilepsy:false,
        diabetes:false, other_chronic_illness:''});


    useEffect(() => {
        axios.get(`${config.smsUrl}/cvisit/retrieve_all_metrics`).then(res => {
            const data = res.data;
            const dt = data ? data : {};
            const metrics = dt.metrics ? dt.metrics : [];
            setAllMetrics(metrics)
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })
    }, [])

    useEffect(() => {
        const filteredArr = allMetrics.filter(item => item.metric_id > 2);
        const tArr = filteredArr.slice(0, 1).map(item => ({
            ...item,
            metric_id: item.metric_id,
            metric_name: `${item.metric_name}(${item.uom ? item.uom : ''})`,
            metric_value: '', name: `metric_${item.metric_id}`
        }))
        setTriage(tArr)
        const tList = filteredArr.slice(1, 3).map(item => ({
            ...item,
            metric_id: item.metric_id,
            metric_name: `${item.metric_name}(${item.uom ? item.uom : ''})`,
            metric_value: '', name: `metric_${item.metric_id}`
        }))
        const other_metrics = filteredArr.slice(3).map(item => ({
            ...item,
            value: item.metric_id,
            label: `${item.metric_name}(${item.uom ? item.uom : ''})`,
            metric_value:''
        }))
        setOthers(other_metrics);
        setTriageList(tList)

    }, [allMetrics])

    const handleChange = (event, index) => {
        const triageCopy = [...triage];
        const {value} = event.target;
        triageCopy[index].metric_value = value;
        setTriage(triageCopy)
        setIsSubmitted('idle')
    };


    const handleChangeOthersMetrics = (value) => {
        setOtherMetric(value)
        const obj = {};
        obj['metric_value'] = '';
        obj['metric_id'] = value.value;
        obj['metric_name'] = value.label;
        const existingIds = optionalMetrics.map((id) => id.metric_id)
        if (!existingIds.includes(value.value)) {
            setOptionalMetrics([...optionalMetrics, obj])
        }
        setIsSubmitted('idle')

        const arr = others.map(item=>{
            if (item.value === value.value){
                return {...item, metric_value:value.value}
            }
            return item
        })
        setOthers(arr)

    }

    const handleChangeOptional = (event, metric_id) => {
        const arr = optionalMetrics.map(metric => {
            if (metric.metric_id === metric_id) {
                return {...metric, metric_value: event.target.value}
            }
            return metric
        })
        setOptionalMetrics(arr)
        setIsSubmitted('idle')
    }

    const removeMetric = (metric_id) =>{
        const arr = optionalMetrics.filter(item=>item.metric_id !== metric_id);
        setOptionalMetrics(arr)
    }

    const handleChangeVitals = (event, index) => {
        const triageCopy = [...triageList];
        const {value} = event.target;
        triageCopy[index].metric_value = value;
        setTriageList(triageCopy)
        setIsSubmitted('idle')
    };

    const calculateBMI = (weight, height) => {
        const h = height ? height : 0;
        if (h > 0) {
            setBMI(((+weight / Math.pow(+h, 2)) * 10000).toFixed(2))
        } else {
            setBMI(0)
        }

    }

    const handleChangeWeight = (event) => {
        const {value} = event.target;
        setWeight(currentState => ({...currentState, weight_metric_name: value}))
        calculateBMI(value, height_metric_name)
        setIsSubmitted('idle')
    }

    const handleChangeHeight = (event) => {
        const {value} = event.target;
        setHeight(currentState => ({...currentState, height_metric_name: value}))
        calculateBMI(weight_metric_name, value)
        setIsSubmitted('idle')
    }


    const handleMedicalIllness = (event) => {
        const {name, checked} = event.target;
        setChronicIllness({...chronic_illness, [name]:checked});
    }

    const handleHasAllergies = (event) => {
        const {value} = event.target
        if(value === 'yes'){
            setHasAllergies(true)
        }else if(value === 'no'){
            setHasAllergies(false)
        }

    }



    const cleareTriage = (arr) =>{
        const listArr = arr.map(item=>({
            ...item, metric_value:''
        }))
        return listArr
    }

    const handleSubmitTriage = (event) => {
        event.preventDefault();
        setSubmitted(true);
        const formData = new FormData(event.currentTarget);
        const fieldValues = Object.fromEntries(formData.entries())
        if(hasAllergies === false && allergies){
            setAllergies('');
        }
        const {other_chronic_illness, ...rest} = chronic_illness
        const illness = fieldValues['chronic_illness']
        const allergyData = fieldValues['allergies'] ? fieldValues['allergies'] : {}
        const others_arr =  others.filter(metric => !metric.metric_value)
        const triage_arr = [...triageList,...triage,...optionalMetrics].filter(metric => metric.metric_value && metric.metric_id)
        const jsonData = {
            'patient_number':patient_number,
            'metric_type_id':1,
            'visit_id' :visit_id,
            'activity_id' : '',
            'visit_state':3,
            'user_roles_id' : user_roles_id,
            'chronic_illness': {...rest, other_chronic_illness:illness},
            allergies: allergyData,

            triage_info : [
                ...triage_arr,...others_arr,
                {
                    'metric_id': height_metric_id,
                    'metric_value': height_metric_name
                },
                {
                    'metric_id': weight_metric_id,
                    'metric_value': weight_metric_name
                }

            ]
        }

        const isTriageList = triageList.some(item=>item.metric_value)
        const isTriage = triage.some(item=>item.metric_value)
        const isRequired = isTriageList || isTriage || height_metric_name || weight_metric_name
        if (patient_number && isRequired) {
            setIsSubmitted('pending');
            axios.post(`${config.smsUrl}/cvisit/add_triage`, jsonData).then(res => {
                setIsSubmitted('resolved');
                actions.snackbarActions.snackSuccess('Triage Information added successfully');
                setTriageList(cleareTriage(triageList));
                setHeight({height_metric_id: 1, height_metric_name: ''});
                setWeight({weight_metric_id: 2, weight_metric_name: ''});
                setOptionalMetrics(cleareTriage(optionalMetrics));
                setTriage(cleareTriage(triage));
                setOtherMetric('');
                setBMI('');
                setSubmitted(false);
                setOpenDialog(false)
            }).catch((err) => {
                errorMessages(err, null, actions)
                setIsSubmitted('rejected');
            });
        }

    };


    const isPending = isSubmitted === 'pending'
    const isResolved = isSubmitted === 'resolved'


    const isTriageList = triageList.some(item=>item.metric_value)
    const isTriage = triage.some(item=>item.metric_value)

    const requiredFields = isTriageList || isTriage || height_metric_name || weight_metric_name


    const theme = useTheme();
    const them  = theme ? theme : {};
    const palette = them.palette ? them.palette : {};

    const {cardiac_disease, kidney_disease, hypertension, tb,
        sickle_cell_disease, epilepsy, diabetes} = chronic_illness;

    const classes = useStyles()
    return (
        <form onSubmit={handleSubmitTriage}>
            {submitted && !requiredFields ?
                <div className='mb-3'>
                    <Alert severity='error'>Please record vitals before saving</Alert>
                </div>
                : null}
            <div className="mt-4">
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <FormLabel name="Weight(kgs)" htmlFor='weight'
                                           toolTip="Weight"/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                <TextField type='number' id='weight' value={weight_metric_name}
                                           onChange={handleChangeWeight} autoComplete="off"/>
                            </Col>
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <FormLabel name="Height(cms)" htmlFor='height'
                                           toolTip="Enter height"/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                <TextField type='number' id='height' value={height_metric_name}
                                           onChange={handleChangeHeight} autoComplete="off"/>
                            </Col>
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <FormLabel name="BMI" htmlFor='bmi'
                                           toolTip="Body mass weight"/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                <TextField value={bmi} id='bmi' disabled/>
                            </Col>
                        </Form.Group>
                    </div>
                    {triage.map((triage, index) => (<div className="col-md-6" key={index}>
                        <Form.Group as={Row} key={triage.metric_id}>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <FormLabel name={titleCase(triage.metric_name)} htmlFor={`triage-metric_value-${index}`}
                                           toolTip="Temperature"/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                <TextField type='number' name={triage.name}
                                           id={`triage-metric_value-${index}`}
                                           onChange={(e) => handleChange(e, index)}
                                           value={triage.metric_value} autoComplete="off"/>
                            </Col>
                        </Form.Group>
                    </div>))}
                </div>
                <div className="row">
                    {triageList.map((triage, index) => (<div className="col-md-6" key={index}>
                        <Form.Group as={Row} key={triage.metric_id}>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <FormLabel name={titleCase(triage.metric_name)} htmlFor={`triage-metric_name-${index}`}
                                           toolTip={`Enter ${triage.metric_name}`}/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                <TextField type='text' name={triage.name}
                                           id={`triage-metric_name-${index}`}
                                           onChange={(e) => handleChangeVitals(e, index)}
                                           value={triage.metric_value} autoComplete="off"/>
                            </Col>
                        </Form.Group>

                    </div>))}
                </div>
                {optionalMetrics.length > 0 ? <div className="row">
                    {optionalMetrics.map(triage => (<div className="col-md-6" key={triage.metric_id}>
                        <Form.Group as={Row} key={triage.metric_id}>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <FormLabel name={titleCase(triage.metric_name)}
                                           toolTip={`Enter ${triage.metric_name}`}/>
                            </Col>
                            <Col xs={10} sm={10} md={10} lg={6} xl={6}>

                                <TextField type='text' name={triage.name} autoComplete="off"
                                           onChange={(e) => handleChangeOptional(e, triage.metric_id)}
                                           value={triage.metric_value}/>
                            </Col>
                            <Col xs={2} sm={2} md={2} lg={2} xl={2}>
                                <button type="button" onClick={() => removeMetric(triage.metric_id)}
                                        className='btn btn-sm sms-btn-dismiss'
                                        style={{padding: '0 1px', borderRadius: '50px'}}><ClearIcon
                                    classes={{root: classes.root}}/></button>
                            </Col>
                        </Form.Group>
                    </div>))}
                </div> : null}
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group as={Row}>
                            <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                                <Label name="Add Metric" htmlFor='add_metric'/>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                <CustomSelect value={otherMetric}
                                              onChange={handleChangeOthersMetrics} options={others}
                                              id='addmetric'/>
                            </Col>
                        </Form.Group>
                    </div>
                </div>
                <h6
                    className={`visit-heading ${
                        palette.type === "dark" && "dark-visit-heading"
                    }`}
                >
                    <strong>Chronic diseases and allergy information</strong>
                </h6>

                <div className='row'>
                    <div className='col-lg-6'>
                        <h6>Chronical Diseases</h6>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
                                <div>

                                    <Col>
                                        <Form.Check type="checkbox" label="Cardiac Disease" checked={cardiac_disease}
                                                    name="cardiac_disease" onChange={handleMedicalIllness}/>
                                    </Col>
                                    <Col>
                                        <Form.Check type="checkbox" label="Sickle Cell Disease"
                                                    checked={sickle_cell_disease} name="sickle_cell_disease"
                                                    onChange={handleMedicalIllness}/>
                                    </Col>
                                    <Col>
                                        <Form.Check type="checkbox" label="Kidney Disease" checked={kidney_disease}
                                                    name="kidney_disease" onChange={handleMedicalIllness}/>
                                    </Col>
                                    <Col>
                                        <Form.Check type="checkbox" label="Epilepsy (seizures)" checked={epilepsy}
                                                    name="epilepsy" onChange={handleMedicalIllness}/>
                                    </Col>
                                    <Col>
                                        <Form.Check type="checkbox" label="Hypertension" checked={hypertension}
                                                    name="hypertension" onChange={handleMedicalIllness}/>
                                    </Col>
                                    <Col>
                                        <Form.Check type="checkbox" label="Diabetes" checked={diabetes} name="diabetes"
                                                    onChange={handleMedicalIllness}/>
                                    </Col>
                                    <Col>
                                        <Form.Check type="checkbox" label="TB" checked={tb} name="tb"
                                                    onChange={handleMedicalIllness}/>
                                    </Col>
                                    <Col>
                                        <Label name="Others(Specify)" className="label-admission-prescription"/>
                                    </Col>

                                </div>

                                <Col>
                                    <CustomResizableTextarea name='chronic_illness'
                                                             rows={2} inputValue={chronic_illness.other_chronic_illness}
                                                             reset={isResolved} id='chronic_illness'/>
                                    {/*<ResizableTextarea rows={2} value={chronic_illness.other_chronic_illness} onChange={handleOtherMedicals}/>*/}
                                </Col>
                            </Col>

                        </Row>
                    </div>
                    <div className='col-lg-6'>
                        <h6>Allergies</h6>
                        <Label name="Do you have any allergies?" className="label-admission-prescription"/>
                        <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                            <Form.Check
                                inline
                                type="radio"
                                name="allergy"
                                className="form__label"
                                label="Yes"
                                value="yes"
                                checked={hasAllergies === true}
                                onChange={handleHasAllergies}
                            />
                            <Form.Check
                                inline
                                type="radio"
                                name="allergy"
                                className="form__label"
                                label="No"
                                value="no"
                                checked={hasAllergies === false}
                                onChange={handleHasAllergies}
                            />
                            {
                                hasAllergies ?

                                    <CustomResizableTextarea name='allergies'  rows={2}
                                                             inputValue={allergies}
                                                             reset={isResolved} id='allergies'/>

                                    : null}
                        </Col>
                        <RightAlignedContainer>
                            <button type="submit" disabled={isPending}
                                    className="btn btn-sm sms-btn mt-3">{isPending ? 'Saving...' : 'Save vitals'}</button>
                        </RightAlignedContainer>
                    </div>
                </div>

            </div>
        </form>
    )
};

export default RecordTriage;
